import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.user.info;
//VERIFY IF THE JWT IS SET
const isUserLoggedIn = createSelector(getData, info => !isEmpty(info));
export default isUserLoggedIn;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/isUserLoggedIn.js